module.exports = __webpack_public_path__ + "static/media/asparagus.e8068ef1.jpg";